/**
 * wireMatchEndHonor — Post-game MVP / honor stub + chip + __debugHonor (SPY-315 / SPY-415 / SPY-515).
 */

import { resolveMatchEndHonorAction } from '../../domain/match/matchEndHonor.js';
import { createMatchEndHonorChipController } from './matchEndHonorChipController.js';

/**
 * @param {{
 *   documentRef?: { getElementById?: Function },
 *   globalObj?: object|null
 * }} [opts]
 */
export function wireMatchEndHonor({
  documentRef = globalThis.document,
  globalObj = typeof window !== 'undefined' ? window : null
} = {}) {
  const state = { last: null, history: [] };
  const HISTORY_CAP = 14;
  let chip = null;

  function apply(actionId) {
    const action = resolveMatchEndHonorAction(actionId);
    if (!action) return null;
    state.last = { ...action, at: state.history.length };
    state.history.push(state.last);
    while (state.history.length > HISTORY_CAP) state.history.shift();
    chip?.setLastActionEcho?.(state.last.label);
    chip?.show?.();
    return state.last;
  }

  chip = createMatchEndHonorChipController({
    rootEl: documentRef?.getElementById?.('match-end-honor-chip') || null,
    honorBtnEl: documentRef?.getElementById?.('match-end-honor-btn') || null,
    mvpBtnEl: documentRef?.getElementById?.('match-end-mvp-btn') || null,
    echoEl: documentRef?.getElementById?.('match-end-honor-echo') || null,
    onHonor: () => apply('honor'),
    onMvp: () => apply('mvp')
  });

  const api = {
    mvp: () => apply('mvp'),
    honor: () => apply('honor'),
    last: () => state.last,
    list: () => state.history.slice(),
    actionHistory: () => state.history.slice(),
    clearActions: () => {
      state.history = [];
      state.last = null;
    },
    undoLastAction: () => {
      if (state.history.length === 0) return null;
      state.history.pop();
      state.last = state.history.length
        ? state.history[state.history.length - 1]
        : null;
      chip?.setLastActionEcho?.(state.last?.label || '');
      return state.last;
    },
    actionCount: () => state.history.length,
    showChip: () => chip.show(),
    hideChip: () => chip.hide(),
    isChipVisible: () => chip.isVisible(),
    lastActionEcho: () => chip.getLastActionEcho()
  };

  if (globalObj) globalObj.__debugHonor = api;
  return { ...api, chip, debugApi: globalObj?.__debugHonor || null };
}
